// AIDEV-NOTE: List of common airlines for flight selection dropdown
export const airlines = [
    { airlineName: 'American Airlines', airlineCode: 'AA' },
    { airlineName: 'Southwest Airlines', airlineCode: 'WN' },
    { airlineName: 'United Airlines', airlineCode: 'UA' },
    { airlineName: 'Other', airlineCode: 'OT' },
];

export const validAirlines = ['WN', 'AA', 'UA'];
